export default __webpack_public_path__ + "static/media/snow.df94ba04.png";